export const rankingTabDefinitions = [
  { label: 'Greyhound', route: '/rankings/greyhound' },
  { label: 'Sire', route: '/rankings/sire' },
  { label: 'Dam', route: '/rankings/dam' },
  { label: 'Trainer', route: '/rankings/trainer' }
];
